import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const env = process.env.REACT_APP_ENV;
const base = env === "prod" ? process.env.REACT_APP_API_URL_PROD : 'http://localhost:5000';

export const customBaseQuery = async (args, api, extraOptions) => {
  const { schema, prefix = "", ...rest } = args;
  let url = "/api";

  if (schema?.includes("keys")){
    url += "/keys";
  }

  if (schema) url += `/${schema}`;
  if (prefix) url += `/${prefix}`;
  url += rest.url;

  let initData = sessionStorage.getItem("initData") || window.Telegram?.WebApp.initData;

  const rawBaseQuery = fetchBaseQuery({
    baseUrl: base,
    prepareHeaders: (headers) => {
      if (initData) {
        headers.set("X-Telegram-InitData", initData);
      }
      return headers;
    },
  });

  return rawBaseQuery({ ...rest, url }, api, extraOptions);
};